import React from 'react';
import SharedNavbarTop from 'shared_items/NavbarTop';

// Settings toggle real (alterna configurações/voltar) — mesmo padrão de
// finance/health. Era fixo em settingsActive={false} antes (só ida, nunca
// voltava pelo botão) — corrigido junto com a reconstrução do módulo Core,
// 2026-08-19.
const NavbarTop = ({ title, onHomeClick, onLogoutClick, handleTabChange, activeTab }) => (
  <SharedNavbarTop
    title={title}
    moduleKey="core"
    onHomeClick={onHomeClick}
    settingsActive={activeTab === 'settings'}
    onSettingsClick={() => handleTabChange(activeTab === 'settings' ? 'frameworks' : 'settings')}
  />
);

export default NavbarTop;
